module.exports = __webpack_public_path__ + "img/marca1.9a6d770c.png";